import client from '/src/services/client.js';
import { env } from "/src/var/env";
export default {
    getMemos: (data) => client.get('memos', data),

    addMemo: (data) => client.post(`memo`, data),
    editMemo: (id, data) => client.put(`memo/${id}`, data),
    deleteMemo: (id, data) => client.delete(`memo/${id}`, data),

    getCategories: (data) => client.get('memos/categories', data)
}